export default __webpack_public_path__ + "static/media/Vibrant.36e08be9.svg";